import { Contact, Faq, Footer, Header, History, Mission, Schedule, Zapzap } from '../index';

export function Main() {
    return(
        <>
              <Zapzap></Zapzap>
              <Header></Header>
              <History></History>
              <Schedule></Schedule>
              <Faq></Faq>
              <Mission></Mission>
              <Contact></Contact>
              <Footer></Footer>
            </>
    )
}